import * as $ from 'jquery';
import 'bootstrap';
require('datatables.net');
require('datatablesResponsive');
require('datatablesFixedColumns');

export class configureTable{
	cabinTable(): any{
	let $getDataAuthor:any = $('.configurable-table--container').attr('data-author');
	let $getTabPane: any = $('.configurable-table--container .tab-content > .tab-pane');
	if($getDataAuthor == "true"){
		$getTabPane.css('display', 'block');
		$getTabPane.removeClass('fade');
	}

	$('a[data-toggle="tab"]').on( 'shown.bs.tab', function (e:any) {
		// $.fn.dataTable.tables( {visible: true, api: true} ).columns.adjust();
		$.fn.dataTable.tables( {visible: true, api: true} ).draw();
	});

	$('.configure-table').each(function(){
		let _configTable:any = $(this);

		_configTable.DataTable({
			bFilter: false,
			bLengthChange: false,
			'bSort': false,
			'bPaginate': false,
			'bInfo': false,
			'scrollX': true,
			'scrollCollapse': true,
			'paging': false,
			fixedColumns: {
				leftColumns: 1
			}
		});
	});

	let $viewportWidth:any = $(window).width();
		$(window).load(function() {
			if($viewportWidth < 767){
				let $secondaryNav: any = $('.sec-navigation, .sec-navigation ul li');
				let $secondaryNavLi: any = $('.sec-navigation ul li').length;
				if($secondaryNavLi > 3){
					let $secondaryNavArrow: any = $('.sec-nav--arrow');
					$secondaryNavArrow.show();
					$secondaryNav.on('touchstart mousedown', function(e:any){
						$secondaryNavArrow.css('opacity', 0);
					});
					$secondaryNav.on('touchend mouseup', function(e:any){
						$secondaryNavArrow.css('opacity', 0.2);
					});
				}
			} else{
				let $secondaryNav: any = $('.sec-navigation, .sec-navigation ul li');
				let $secondaryNavLi: any = $('.sec-navigation ul li').length;
				if($secondaryNavLi > 7){
					let $secondaryNavArrow: any = $('.sec-nav--arrow');
					$secondaryNavArrow.show();
					$secondaryNav.on('touchstart mousedown', function(e:any){
						$secondaryNavArrow.css('opacity', 0);
					});
					$secondaryNav.on('touchend mouseup', function(e:any){
						$secondaryNavArrow.css('opacity', 0.2);
					});
				}
			}
		});
	}
}

let scope:Element = document.querySelector('.configurable-table--container');
if (scope){
	try {
	let configuretable = new configureTable();
		configuretable.cabinTable();
	} catch(e) {console.error(e);}
}
